import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLoginPopup } from 'features/account/login/useLoginPopup';
import { usePopup } from 'hooks/usePopup';
import { ROUTE_HOME } from 'navigation/config/routePaths';

import AccountCheckPopup from './AccountCheckPopup';

interface Props {
  onClose?: () => void;
  onContinueAsGuest?: () => void;
  onLogin?: () => void;
}

export const useOnSiteAccountCheck = () => {
  const { showPopup, hidePopup } = usePopup();
  const { showLoginPopup, hideLoginPopup } = useLoginPopup();
  const navigate = useNavigate();

  const showAccountCheck = useCallback(
    ({ onContinueAsGuest, onLogin }: Props = {}) => {
      const handleHasAccount = () => {
        hidePopup();
        showLoginPopup({
          onLogged: () => {
            if (onLogin) {
              onLogin();
              hideLoginPopup();
            }
          },
          onClose: () => {
            hideLoginPopup();
            navigate(ROUTE_HOME);
          },
        });
      };

      const handleNoAccount = () => {
        hidePopup();
        onContinueAsGuest?.();
      };

      showPopup(<AccountCheckPopup onHasAccount={handleHasAccount} onNoAccount={handleNoAccount} />, {
        onClose: () => {
          hidePopup();
          navigate(ROUTE_HOME);
        },
        hasBlur: true,
      });
    },
    [showPopup, hidePopup, showLoginPopup, navigate]
  );

  return { showAccountCheck };
};
